<span (click)="iconClick()">
  @if (isSelected()) {
    <i class="mdi mdi-star"></i>
  } @else {
    <i class="mdi mdi-star-outline"></i>
  }
</span>
